export const environment = {
  production: true,
  defaultCulture: "en-US",
  version: '4.61.24018.1825-release-4-61'
};
